import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import esCommon from '@/locales/es/common.json';
import enCommon from '@/locales/en/common.json';

export const supportedLngs = ['es', 'en'] as const;
export type SupportedLng = (typeof supportedLngs)[number];
export const defaultLng: SupportedLng = 'es';

export const STORAGE_KEY = 'cms-central-lang';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: defaultLng,
    supportedLngs: supportedLngs as unknown as string[],
    ns: ['common'],
    defaultNS: 'common',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: STORAGE_KEY,
    },
    resources: {
      es: { common: esCommon },
      en: { common: enCommon },
    },
    interpolation: { escapeValue: false },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
    },
    returnNull: false,
  });

export function changeLanguage(lng: SupportedLng) {
  void i18n.changeLanguage(lng);
  document.documentElement.lang = lng;
}

document.documentElement.lang = i18n.language?.split('-')[0] ?? defaultLng;

export default i18n;
